// PageVariablesEmpresas.js

export const pageVariables = {
    
    headers: [
       'NOME', 'IDADE','STATUS', 'DATA DE CONTATO', 'DATA RETORNO', 'DATA DE VISITA', 'AGENDAMENTO', 'AGENDADOR', 'CONSULTOR', 'STATUS DO CONTATO', 'STATUS COMERCIAL'
    ],
    headerInfo: {
        title: "Gerenciamento e Rotas",
        description: "Gerencie os Rotas em tempo real"
    },    
    inputs: [
    
        {
            name: "observacao",
            type: "select",
            label: "Obeservações",
        }
        
    ],
    consultores: [
    ],
    consultoresPage: process.env.VUE_APP_API_URL+"get-group-members/consultores",
    page: process.env.VUE_APP_API_URL+"listas",
    getPageLista: process.env.VUE_APP_API_URL+"getListas",
    listaViewPage: process.env.VUE_APP_API_URL+"lista",
    
};
